module.exports = __webpack_public_path__ + "images/intro_iphone_remote_control.jpeg?4604a1a5a3c0914f7c88ac9cd9c0d4da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro_iphone_remote_control.jpeg
// module id = 62
// module chunks = 0